export default __webpack_public_path__ + "static/logo-c8e6c3cf6caf316585b76b41e01c1fef.png";